(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["notifications"] && !Shopify.designMode) return;
  try {
    

  var moreThanOneNotification = document.querySelectorAll('.notifications li').length > 1;
  if(moreThanOneNotification) {
  //document.querySelector('.notifications li:first-child').classList.add('first');
  document.querySelector('.notifications li:last-child').classList.add('last');
  if (moreThanOneNotification != false) {
    document.querySelector('.notifications li:first-child').classList.add('first');
  } else {
    document.querySelector('.notifications li:first-child').classList.add('showOnlyOne');
  }

  if (moreThanOneNotification != false) {
    setTimeout(() => {
      changeClass();
    }, '10000');
  }

  function changeClass() {
    document.querySelectorAll('.first').forEach(function (element, idx, array) {
      element.classList.remove('first');
      // console.log(element.classList);

      if (!element.classList.contains('last')) {
        element.nextElementSibling.classList.add('first');
      } else {
        document.querySelector('.notifications li:first-child').classList.add('first');
      }

      setTimeout(() => { 
        changeClass();
      }, '10000');
    });
  }

}

  } catch(e) { console.error(e); }
})();
})();
